"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeviceInfo = void 0;
const device_core_1 = require("@ledgerhq/device-core");
const errors_1 = require("@ledgerhq/errors");
const logs_1 = require("@ledgerhq/logs");
const getAppAndVersion_1 = require("./getAppAndVersion");
const ManagerAllowedFlag = 0x08;
const PinValidatedFlag = 0x80;
const DeviceNotOnboarded = (0, errors_1.createCustomErrorClass)("DeviceNotOnboarded");
const dashboardNames = ["BOLOS", "OLOS\u0000"];
const isDashboardName = (name) => dashboardNames.includes(name);
const isDevFirmware = (seVersion) => {
    if (!seVersion)
        return false;
    const knownDevSuffixes = ["lo", "rc", "il", "tr"]; // FW can't guarantee non digits in versions
    return knownDevSuffixes.some((suffix) => seVersion.includes("-" + suffix));
};
const getDeviceInfo = (transport) => __awaiter(void 0, void 0, void 0, function* () {
    const tracer = new logs_1.LocalTracer("hw", Object.assign(Object.assign({}, transport.getTraceContext()), { function: "getDeviceInfo" }));
    tracer.trace("Starting get device info");
    const probablyOnDashboard = yield (0, getAppAndVersion_1.getAppAndVersion)(transport)
        .then(({ name }) => isDashboardName(name))
        .catch((e) => {
        tracer.trace(`Error from getAppAndVersion: ${e}`, { error: e });
        if (e instanceof errors_1.TransportStatusError) {
            if (e.statusCode === 0x6e00) {
                return true;
            }
            if (e.statusCode === 0x6d00) {
                return false;
            }
        }
        throw e;
    });
    if (!probablyOnDashboard) {
        tracer.trace(`Device not on dashboard`);
        throw new errors_1.DeviceOnDashboardExpected();
    }
    const res = yield (0, device_core_1.getVersion)(transport).catch((e) => {
        tracer.trace(`Error from getVersion: ${e}`, { error: e });
        if (e instanceof errors_1.TransportStatusError) {
            if (e.statusCode === 0x6d06 || e.statusCode === 0x6d07) {
                throw new DeviceNotOnboarded();
            }
        }
        throw e;
    });
    const { isBootloader, rawVersion, targetId, seVersion, seTargetId, mcuBlVersion, mcuVersion, mcuTargetId, bootloaderVersion, hardwareVersion, languageId, charonState, flags, } = res;
    const isOSU = rawVersion.includes("-osu");
    const version = rawVersion.replace("-osu", "");
    const m = rawVersion.match(/([0-9]+.[0-9]+(.[0-9]+){0,1})?(-(.*))?/);
    const [, majMin, , , postDash] = m || [];
    const providerName = device_core_1.PROVIDERS[postDash] ? postDash : null;
    const flag = flags.length > 0 ? flags[0] : 0;
    const managerAllowed = !!(flag & ManagerAllowedFlag);
    const pinValidated = !!(flag & PinValidatedFlag);
    let isRecoveryMode = false;
    let onboarded = true;
    if (flags.length === 4) {
        // Nb Since LNS+ unseeded devices are visible + extra flags
        isRecoveryMode = !!(flags[0] & 0x01);
        onboarded = !!(flags[0] & 0x04);
    }
    (0, logs_1.log)("hw", "deviceInfo: se@" + version + " mcu@" + mcuVersion + (isOSU ? " (osu)" : isBootloader ? " (bootloader)" : ""));
    const hasDevFirmware = isDevFirmware(seVersion);
    return {
        version,
        mcuVersion,
        seVersion,
        mcuBlVersion,
        majMin,
        providerName: providerName || null,
        targetId,
        hasDevFirmware,
        seTargetId,
        mcuTargetId,
        isOSU,
        isBootloader,
        isRecoveryMode,
        managerAllowed,
        pinValidated,
        onboarded,
        bootloaderVersion,
        hardwareVersion,
        languageId,
        charonState,
        seFlags: flags,
    };
});
exports.getDeviceInfo = getDeviceInfo;
//# sourceMappingURL=getDeviceInfo.js.map